import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

// Wraps the self-contained calculator HTML (public/tools/) in site chrome via a same-origin iframe.
export default function RecoveryCalculatorPage() {
  const [html, setHtml] = useState(null);
  const frameRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Recovery Payback Calculator — Gym Amenity ROI | NinjAthlete';
    const meta = document.querySelector('meta[name="description"]');
    const prev = meta?.getAttribute('content');
    meta?.setAttribute('content', 'Interactive payback calculator for 11 gym recovery amenities — sauna, cold plunge, contrast suite, red light and more. Edit member count, tier price and take rate; rankings update live.');
    fetch('/tools/recovery-payback-calculator.html')
      .then((r) => r.text())
      .then(setHtml)
      .catch(() => {});
    return () => { if (prev) meta?.setAttribute('content', prev); };
  }, []);

  const resize = () => {
    try {
      const doc = frameRef.current?.contentDocument;
      if (doc) frameRef.current.style.height = `${doc.documentElement.scrollHeight + 40}px`;
    } catch { /* noop */ }
  };

  return (
    <main className="pt-20 min-h-screen bg-[#050505]" data-testid="recovery-calculator-page">
      <div className="container-ninja pt-6">
        <Link to="/blogs/article/recovery-amenities-gym-economics" className="inline-flex items-center gap-1.5 text-zinc-500 hover:text-white text-xs uppercase tracking-widest transition-colors" data-testid="recovery-calc-back-link">
          <ArrowLeft className="w-3.5 h-3.5" /> Read the full article
        </Link>
      </div>
      {html ? (
        <iframe
          ref={frameRef}
          title="Recovery Payback Calculator"
          srcDoc={html}
          onLoad={resize}
          className="w-full border-0 block"
          style={{ height: '2400px' }}
          data-testid="recovery-calculator-frame"
        />
      ) : (
        <div className="flex justify-center py-24"><div className="w-8 h-8 border-2 border-[#C7FA3E] border-t-transparent rounded-full animate-spin" /></div>
      )}
    </main>
  );
}
